import { render } from "./JobTagsSection.vue?vue&type=template&id=c4685f1a&scoped=true"
import script from "./JobTagsSection.vue?vue&type=script&lang=js"
export * from "./JobTagsSection.vue?vue&type=script&lang=js"

import "./JobTagsSection.vue?vue&type=style&index=0&id=c4685f1a&scoped=true&lang=css"

import exportComponent from "/var/www/matchmaker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4685f1a"]])

export default __exports__